export * from "./translate.pipe";
export * from "./date.pipe";
export * from "./numeric.pipe";


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/pipes/index.ts